import { actions } from '../reducers/system/systemReducer';

export default {
    display: (content) => {
        window.ConnectReduxStore.dispatch({
            type: actions.SHOW_SNACKBAR_MESSAGE,
            content: content
        });
    }
};
